import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { easeOut } from '../../utils/motion';
export type SectionState = 'active' | 'done' | 'locked';
interface CheckoutSectionProps {
  index: number;
  title: string;
  state: SectionState;
  summary?: React.ReactNode;
  onEdit?: () => void;
  children: React.ReactNode;
}
export function CheckoutSection({
  index,
  title,
  state,
  summary,
  onEdit,
  children
}: CheckoutSectionProps) {
  const headingId = `checkout-step-${index}`;
  return <section aria-labelledby={headingId} className="border-b border-line py-6 md:py-8" data-id="element-78" data-mp="1hfjkazh4btl5">
      <div className="flex items-center justify-between gap-4" data-id="element-79" data-mp="1ce41le2exz5x">
        <h2 id={headingId} className="flex items-center gap-3" data-id="element-80" data-mp="17hdl4pmp51jz">
          <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors duration-200 ${state === 'done' ? 'bg-sage text-paper' : state === 'active' ? 'bg-ink text-paper' : 'border border-line text-muted'}`} aria-hidden data-id="element-81" data-mp="17iydq9pgaaf7">
            {state === 'done' ? <CheckIcon className="h-3.5 w-3.5" data-id="element-82" data-mp="1tqabdhr5asab" /> : index}
          </span>
          <span className={`font-display text-2xl md:text-3xl ${state === 'locked' ? 'text-muted' : ''}`} data-id="element-83" data-mp="1fru3volgkxr4">{title}</span>
          {state === 'done' && <span className="sr-only" data-id="element-84" data-mp="1koavwtvs3w9h">(terminé)</span>}
        </h2>
        {state === 'done' && onEdit && <button type="button" onClick={onEdit} className="text-sm underline underline-offset-4 hover:text-clay" data-id="element-85" data-mp="15z4x370us824">
            Modifier
          </button>}
      </div>
      {state === 'done' && summary && <div className="mt-3 pl-10 text-sm text-muted" data-id="element-86" data-mp="wyqam4c5kmx1">{summary}</div>}
      <AnimatePresence initial={false} data-id="element-87" data-mp="1205tbpquyhc9">
        {state === 'active' && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="overflow-hidden" data-id="element-88" data-mp="n3et5e9d11ll">
            <div className="pt-6 md:pl-10" data-id="element-89" data-mp="45ldcyzefim7">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}